import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import _defineProperty from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * 全站权限配置
 *
 */
import router from "./router/router";
import store from '@/store';
import { validatenull } from '@/util/validate';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
NProgress.configure({
  showSpinner: false
});
var lockPage = store.getters.website.lockPage; // 锁屏页
router.beforeEach(function (to, from, next) {
  // 缓冲设置
  if (to.meta.keepAlive === true && store.state.tags.tagList.some(function (ele) {
    return ele.value === to.fullPath;
  })) {
    to.meta.$keepAlive = true;
  } else {
    NProgress.start();
    if (to.meta.keepAlive === true && validatenull(to.meta.$keepAlive)) {
      to.meta.$keepAlive = true;
    } else {
      to.meta.$keepAlive = false;
    }
  }
  var meta = to.meta || {};
  if (store.getters.access_token) {
    if (store.getters.isLock && to.path !== lockPage) {
      next({
        path: lockPage
      });
    } else if (to.path === '/login') {
      next({
        path: '/'
      });
    } else {
      if (store.getters.roles.length === 0) {
        store.dispatch('GetUserInfo').then(function () {
          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
        }).catch(function () {
          store.dispatch('FedLogOut').then(function () {
            next({
              path: '/login'
            });
          });
        });
      } else {
        var value = to.query.src || to.fullPath;
        var label = to.query.name || to.name;
        if (meta.isTab !== false && !validatenull(value) && !validatenull(label)) {
          if (meta.repeatAddTag === true || meta.repeatAddTag === false) {
            store.commit('ADD_TAG', {
              label: label,
              value: value,
              params: to.params,
              query: to.query,
              repeatAddTag: meta.repeatAddTag,
              group: router.$avueRouter.group || []
            });
          } else {
            store.commit('ADD_TAG', {
              label: label,
              value: value,
              params: to.params,
              query: to.query,
              group: router.$avueRouter.group || []
            });
          }
        }
        next();
      }
    }
  } else {
    if (meta.isAuth === false) {
      console.log('我在这里1');
      next();
    } else {
      console.log('我在这里');
      next('/home');
      // next('/login')
    }
  }
});

router.afterEach(function () {
  NProgress.done();
  var title = store.getters.tag.label;
  router.$avueRouter.setTitle(title);
});